import { gql } from '@apollo/client'

export default gql`
  mutation updateAnswer($assignmentId: ID!, $text: String) {
    updateAnswer(assignmentId: $assignmentId, text: $text) {
      id
      assignmentId
      text
      evidence
      submittedAt
      updatedAt
    }
  }
`
